<template>
    <div class="content">
        <div class="box" v-for="item, index in list" :key="index">
            <van-field v-model="item.username" label="账号" readonly />
            <van-field v-model="item.password" center clearable label="密码" placeholder="密码" readonly>
                <template #button>
                    <van-button size="small" type="info" @click="copyText(item.password)">复制密码</van-button>
                </template>
            </van-field>
        </div>
    </div>
</template>
<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'

    export default {
        name: "posPassword",
        data() {
            return {
                list: [],
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                request({
                    url: `/my/password`,
                    method: "get",
                }).then((res) => {
                    this.list = res.data;
                }).catch((error) => {
                    Toast({ position: "top", message: error ?? "" });
                });
            },
            copyText(text) {
                this.$copyText(text).then(function (e) {
                    Toast({ position: 'top', message: '复制成功' })
                }, function (e) {
                    Toast({ position: 'top', message: '复制失败' })
                })
            },

        }
    }
</script>
<style lang="less">
    @import ".././../../assets/css/style.less";
</style>
<style scoped lang="less">
    .content {
        width: 100%;
        height: auto;
        overflow-y: auto;
    }

    .box {
        margin-bottom: 40px;
    }
</style>
